import { BehaviorSubject } from 'rxjs';
import { IModalMessage } from '@molecules/ModalMessages/IModalMessage';

/** Стэк сообщений */
let messages$$: BehaviorSubject<IModalMessage[]> = new BehaviorSubject<IModalMessage[]>([]);

export const getMessages$ = () => messages$$;

export const resetMessages$ = () => {
    if (messages$$.closed) {
        messages$$ = new BehaviorSubject<IModalMessage[]>([]);
    }
};

/** Удалить сообщение */
export const removeModalMsg = (id?: number) => {
    if (messages$$.closed || messages$$.isStopped) {
        return;
    }

    let tmp = [...messages$$.getValue()];

    if (tmp.length > 0) {
        if (id !== undefined) {
            tmp = tmp.filter((n: IModalMessage) => n.id !== id);
        } else {
            tmp.shift();
        }

        messages$$.next(tmp);
    }
};

/** Добавить уведомление */
export const sendModalMsg = (message: IModalMessage) => {
    if (messages$$.closed || messages$$.isStopped) {
        return;
    }

    if (message.message.length > 0) {
        let text: string[] = [];
        if (Array.isArray(message.message)) {
            text = message.message;
        } else {
            text = [message.message];
        }

        const tmp = [...messages$$.getValue()];

        if (
            tmp.length === 0 ||
            !tmp.every((x) => x.message.length === text.length && x.message.join('') == text.join(''))
        ) {
            tmp.push({
                ...message,
                message: text,
                id: message.id || Math.floor(Math.random() * 1000000000),
            });

            messages$$.next(tmp);
        }
    }
};
